import React from "react";

import Typewriter from "typewriter-effect";

export const Type = () => {
  return (
    <>
      <Typewriter
        options={{
          strings: ["Full Stack Web Developer", "Tech Consultant" , "Software Engineer", "MERN Stack Developer"],
          autoStart: true,
          loop: true,
          deleteSpeed: 80
        }}
      />
    </>
  );
};
